// extracted by mini-css-extract-plugin
export default {"description":"SubtopicPreviewCard_description__voyZi"};